// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/company';
// import router from "../router/routes";

const state = {
    // Additional state if needed
    loadingValue: false,
    dashboardData: [],
}

const mutations = {
    UPDATE_LOADING_STATE(state, value) {
        state.loadingValue = value;
    },

    SET_DASHBOARD_DATA(state, data) {
      state.dashboardData = data
  },
}

const actions = {
    // Additional actions if needed
      getDashboardData({ commit }, payload) {
        const user = JSON.parse(localStorage.getItem("user"))
            // return
            return new Promise((resolve, reject) => {
                axios
                    .get(axios.defaults.baseURL + apis.GET_DASHBOARD_DATA_BY_ID + user.id, {
                        headers: {
                          Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                      })
                    .then((res) => {
                        console.log('getDashboardData---', res)
                        commit('SET_DASHBOARD_DATA', res.data.data)
                        // commit("UPDATE_LOADING_STATE", false);
                    })
                    .catch((err) => {
                        console.log('getDashboardData err', err)
                        commit("UPDATE_LOADING_STATE", false);
                    })
            })
    },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
  };